
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IkNhbm5vdCBjb250YWluOiB7bWF0Y2hlc30ifQ==!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IlRpZGFrIGRhcGF0IG1lbmdhbmR1bmc6IHttYXRjaGVzfSJ9!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IlRpZGFrIGRhcGF0IG1lbmdhbmR1bmc6IHttYXRjaGVzfSJ9!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IuC5hOC4oeC5iOC4quC4suC4oeC4suC4o+C4luC4o+C4sOC4muC4uDoge21hdGNoZXN9In0=!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IuC5hOC4oeC5iOC4quC4suC4oeC4suC4o+C4luC4o+C4sOC4muC4uDoge21hdGNoZXN9In0=!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IlRpZGFrIGRhcGF0IG1lbmdhbmR1bmc6IHttYXRjaGVzfSJ9!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IlRpZGFrIGRhcGF0IG1lbmdhbmR1bmc6IHttYXRjaGVzfSJ9!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IuC5hOC4oeC5iOC4quC4suC4oeC4suC4o+C4luC4o+C4sOC4muC4uDoge21hdGNoZXN9In0=!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IuC5hOC4oeC5iOC4quC4suC4oeC4suC4o+C4luC4o+C4sOC4muC4uDoge21hdGNoZXN9In0=!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IlvDh8SDxIPEg+C4geC4teC5ieC4geC4teC5icO2w7bDtuG5ryDDp8O2w7bDtuC4geC4teC5ieG5r8SDxIPEg8Osw6zDrOC4geC4teC5iToge21hdGNoZXN9XSJ9!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJDYW5ub3QgY29udGFpbi4uLiI6IlvDh8SDxIPEg+C4geC4teC5ieC4geC4teC5icO2w7bDtuG5ryDDp8O2w7bDtuC4geC4teC5ieG5r8SDxIPEg8Osw6zDrOC4geC4teC5iToge21hdGNoZXN9XSJ9!"
        )
      )
      });
  
      export { translations as default };
    